<script setup>
import { ref, provide, computed } from 'vue'
import { config } from './config.js'

// 创建黑白模式状态的响应式变量，初始值从配置文件读取
const isBlackWhiteMode = ref(config.enableBlackWhiteMode)

// 提供切换黑白/彩色模式的方法
const toggleBlackWhiteMode = () => {
  isBlackWhiteMode.value = !isBlackWhiteMode.value
}

// 提供设置黑白模式的方法
const setBlackWhiteMode = (enabled) => {
  isBlackWhiteMode.value = enabled
}

// 向所有子组件提供黑白模式控制方法
provide('colorMode', {
  toggleBlackWhiteMode,
  setBlackWhiteMode,
  isBlackWhiteMode
})

// 计算当前应用的类名
const appClasses = computed(() => {
  return {
    'black-white-mode': isBlackWhiteMode.value
  }
})
</script>
<template>
  <div :class="appClasses">
    <router-view />
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
  'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 黑白模式样式 */
.black-white-mode {
  filter: grayscale(100%);
}
</style>
